import { inject, Injectable } from '@angular/core';
import { GeneratedAnswer } from '@repo/backend-api-spec';
import { AnswerReportQueue, MeasurementApiService } from '../../../services';
import { findHomeworkAssignmentUid } from '../homework.utils';
import { LEERPLUS } from '../rid-game.utils';

/**
 * Reports what the pupil answered in an activity to the backend, which turns it into measurements for the
 * recommendations. A no-op where no {@link MeasurementApiService} is provided, and during a tutorial (wizard).
 *
 * Provided by each activity that reports answers, not by the game: only the activity's own leerplus API knows whether
 * the activity is shown by a tutorial.
 */
@Injectable()
export class RidAnswerService {
  private readonly $lpApiService = inject(LEERPLUS.apiToken);
  private readonly $measurementApi = inject(MeasurementApiService, { optional: true });

  private readonly queue = new AnswerReportQueue();

  /**
   * Send everything answered together in one call (one word, or a whole reading list), since the backend records one
   * sample per topic per call. When the activity plays out a homework assignment, the backend also counts the call
   * towards its doel, as one sample.
   */
  public report(answers: GeneratedAnswer[], activityUid: string): void {
    const measurementApi = this.$measurementApi;
    if (!measurementApi || answers.length === 0 || this.$lpApiService.isInWizard) return;

    const assignmentUid = findHomeworkAssignmentUid(this.$lpApiService.state(), activityUid);
    this.queue.enqueue(() => measurementApi.recordAnswers({ answers, activityId: activityUid, assignmentUid }));
  }
}
